var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditInvoice = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 110 110"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  "data-name": "vuesax/bulk/receipt-item"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Vector",
  d: "M100.833 27.5v11.091c0 7.242-4.583 11.825-11.825 11.825H73.333V18.379a9.223 9.223 0 0 1 9.258-9.213A18.309 18.309 0 0 1 100.833 27.5Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Vector",
  d: "M9.167 32.084V96.25a4.569 4.569 0 0 0 7.333 3.667l7.838-5.867a4.618 4.618 0 0 1 6.05.458l7.608 7.659a4.62 4.62 0 0 0 6.508 0l7.7-7.7a4.543 4.543 0 0 1 5.963-.417l7.837 5.867a4.593 4.593 0 0 0 7.333-3.667V18.334A9.194 9.194 0 0 1 82.5 9.167h-55c-13.75 0-18.333 8.2-18.333 18.333Z",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Vector",
  d: "M55 56.191H41.25a3.463 3.463 0 0 0-3.438 3.438 3.463 3.463 0 0 0 3.438 3.437H55a3.463 3.463 0 0 0 3.438-3.437A3.463 3.463 0 0 0 55 56.191ZM41.25 44.733H55a3.463 3.463 0 0 0 3.438-3.437A3.463 3.463 0 0 0 55 37.858H41.25a3.463 3.463 0 0 0-3.438 3.438 3.463 3.463 0 0 0 3.438 3.437ZM27.362 36.712a4.583 4.583 0 1 0 4.584 4.583 4.567 4.567 0 0 0-4.584-4.583ZM27.362 55.045a4.583 4.583 0 1 0 4.584 4.583 4.567 4.567 0 0 0-4.584-4.583Z"
}))));
export default SvgEditInvoice;